module.exports = __webpack_public_path__ + "static/img/RYDER-CORRIGAN.b838d94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RYDER-CORRIGAN.jpg
// module id = yegN
// module chunks = 0